import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IZonaCiudadResponse } from '../interfaces/zona-ciudad.interface';

@Injectable({
  providedIn: 'root'
})
export class ZonaCiudadService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}OpcionesSolicitud/GetZona`;

  constructor(private http: HttpClient) {}

  getZonas(limit: string = '999'): Observable<IZonaCiudadResponse> {
    return this.http.post<IZonaCiudadResponse>(this.API_URL, { limit });
  }

  saveZonaCiudad(payload: { que: number; tope: string; cmd: string; zona: string; descripcion: string }): Observable<any> {
    const url = `${environment.apiNewBackBaseUrl}Zonas/cmspa_zonaAdd`;
    return this.http.post<any>(url, payload);
  }

  getZonaCiudadForEdit(zona: string): Observable<IZonaCiudadResponse> {
    const url = `${environment.apiNewBackBaseUrl}Zonas/cmspa_zonaListDet`;
    const payload = {
      que: 5,
      tope: '',
      cmd: '',
      zona: zona,
      descripcion: ''
    };
    return this.http.post<IZonaCiudadResponse>(url, payload);
  }

  getCiudadesPorZona(zona: string) {
    return this.http.post<any>(`${environment.apiNewBackBaseUrl}OpcionesSolicitud/GetZonasCiu`, { zona });
  }

  createCiudad(payload: { zona: string; claveCd: string; ciu_mun_del: string }) {
    const url = `${environment.apiNewBackBaseUrl}Ciudades/cmspa_zonaciudadesAdd`;
    return this.http.post<any>(url, {
      que: 1,
      tope: '',
      cmd: '',
      ...payload
    });
  }

  getCiudadForEdit(zona: string, claveCd: string) {
    const url = `${environment.apiNewBackBaseUrl}Ciudades/cmspa_zonaciudadesListDet`;
    const payload = {
      que: 5,
      tope: '',
      cmd: '',
      zona: zona,
      claveCd: claveCd,
      ciu_mun_del: ''
    };
    return this.http.post<any>(url, payload);
  }

  updateCiudad(payload: { zona: string; claveCd: string; ciu_mun_del: string }) {
    const url = `${environment.apiNewBackBaseUrl}Ciudades/cmspa_zonaciudadesUpd`;
    return this.http.post<any>(url, {
      que: 2,
      tope: '',
      cmd: '',
      ...payload
    });
  }

  deleteCiudad(zona: string, claveCd: string) {
    const url = `${environment.apiNewBackBaseUrl}Ciudades/cmspa_zonaciudadesDelete`;
    const payload = {
      que: 3,
      tope: '',
      cmd: '',
      zona: zona,
      claveCd: claveCd,
      ciu_mun_del: ''
    };
    return this.http.post<any>(url, payload);
  }

  updateZonaCiudad(payload: { zona: string; descripcion: string }) {
    const url = `${environment.apiNewBackBaseUrl}Zonas/cmspa_zonaUpd`;
    return this.http.post<any>(url, {
      que: 4,
      tope: '',
      cmd: '',
      ...payload
    });
  }

  deleteZonaCiudad(zona: string) {
    const url = `${environment.apiNewBackBaseUrl}Zonas/cmspa_zonaDelete`;
    const payload = {
      que: 3,
      tope: '',
      cmd: '',
      zona: zona,
      descripcion: ''
    };
    return this.http.post<any>(url, payload);
  }
} 